export default __webpack_public_path__ + "static/media/Icon3.5b1d0302.svg";